export default function Callback() {

    document.querySelectorAll('.toggle-callback')
        .forEach(item => {
            item.addEventListener('click', (e) => {
                let url = item.getAttribute('href'),
                    anchor = url.split('#')[1],
                    modal;
                if(!_.isNil(anchor)){
                    e.preventDefault();
                    modal = document.getElementById(`${anchor}`);
                    modal.classList.add("callback__open");
                }

            })
        })

    document.querySelectorAll('.callback__close')
        .forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                let modal = item.closest('.callback');
                modal.classList.remove("callback__open");
            })
        })

    function fieldPreparation(){
        var credentials = Comagic.getCredentials();
        for (var field in credentials) {
            if (credentials.hasOwnProperty(field)){
                document.querySelectorAll('[name=' + field + ']').forEach(ffield => {
                    ffield.value = String(credentials[field]);
                })
            }
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        setTimeout(fieldPreparation, 5000);
    });
}
